import { render, staticRenderFns } from "./coursePage.vue?vue&type=template&id=2aae4c6e&scoped=true&"
import script from "./coursePage.vue?vue&type=script&lang=js&"
export * from "./coursePage.vue?vue&type=script&lang=js&"
import style0 from "./coursePage.vue?vue&type=style&index=0&id=2aae4c6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aae4c6e",
  null
  
)

export default component.exports